var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GoogleDocIcon } from '@web/components/ui/icons/GoogleDocIcon';
import { GoogleDocOrangeIcon } from '@web/components/ui/icons/GoogleDocOrangeIcon';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToDriveAdvancedSearch } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { DriveEventActionEnum } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { getPercentageDiff } from '@workalizer/shared/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var userActivityResolvingValueDiffPair = [
    widgetMetricTableColMetricValueStyle,
    { width: '11%', minWidth: '5.125rem' }
];
var userActivityResolvingTableColgroup = __spreadArray(__spreadArray([
    { width: '32%', minWidth: '11rem' }
], userActivityResolvingValueDiffPair, true), userActivityResolvingValueDiffPair, true);
var getResolvingPeriodDiff = function (document, metric) { var _a, _b; return (_b = (_a = document.previousPeriod) === null || _a === void 0 ? void 0 : _a[metric]) !== null && _b !== void 0 ? _b : getPercentageDiff(0, document[metric]); };
export var UserActivityOnResolving = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var navigateToDocumentSearch = function (title, driveSearchAction) {
        if (driveSearchAction === void 0) { driveSearchAction = null; }
        navigateToDriveAdvancedSearch(navigationScope, {
            driveSearchTitle: title,
            driveSearchAction: driveSearchAction,
            driveSearchSubAction: null
        });
    };
    var _c = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _c[0], setDisplayedCount = _c[1];
    var _d = trpc.userActivityOnResolving.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), userActivityData = _d.data, isLoading = _d.isLoading, refetch = _d.refetch;
    if (isLoading || !userActivityData) {
        return _jsx(Loading, {});
    }
    var documents = (_b = userActivityData.documents) !== null && _b !== void 0 ? _b : [];
    var displayedDocuments = documents.slice(0, displayedCount);
    var hasMore = documents.length > displayedCount;
    var displayedUserActivityData = __assign(__assign({}, userActivityData), { documents: displayedDocuments });
    var columns = [
        {
            title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documentName'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx(GoogleDocIcon, { width: "16", height: "16" }), t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.suggestionsResolved')] }))),
            isVisible: true,
            colspan: 2,
            className: widgetMetricTablePairHeaderThClass
        },
        {
            title: (_jsxs("div", __assign({ className: "flex items-center gap-2" }, { children: [_jsx(GoogleDocOrangeIcon, {}), t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.commentsResolved')] }))),
            isVisible: true,
            colspan: 2,
            className: widgetMetricTablePairHeaderThClass
        }
    ];
    var tableData = displayedDocuments.map(function (document) {
        var rk = String(document.documentId);
        var metricCells = function (current, periodDiff, prefix, driveSearchAction) { return [
            {
                id: "".concat(prefix, "-value-").concat(rk),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: function () {
                        return navigateToDocumentSearch(document.documentTitle, driveSearchAction);
                    } }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: current })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(prefix, "-period-").concat(rk), periodDiff, TablesDiffColorsConfig.GREEN)
        ]; };
        return __spreadArray(__spreadArray([
            {
                id: "documentName-".concat(rk),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 max-w-full cursor-pointer text-base font-semibold break-words", onClick: function () { return navigateToDocumentSearch(document.documentTitle); } }, { children: document.documentTitle }))); }
            }
        ], metricCells(document.suggestionsResolved, getResolvingPeriodDiff(document, 'suggestionsResolved'), 'suggestionsResolved', DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION), true), metricCells(document.commentsResolved, getResolvingPeriodDiff(document, 'commentsResolved'), 'commentsResolved', DriveEventActionEnum.DOCUMENT_RESOLVE_COMMENT), true);
    });
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.resolvingCommentsAndSuggestionsActivity'), description: t('widgetTitleDescriptions.initiativeAndOwnership.resolvingCommentsAndSuggestionsActivity'), insightType: InsightTypeEnum.userActivityOnResolving, insightsData: displayedUserActivityData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.resolvingCommentsAndSuggestionsActivity'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, displayedDocuments.map(function (document) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.documentName')] = document.documentTitle,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.suggestionsResolved')] = document.suggestionsResolved,
                                        _a[t('app.performanceReview.employeePerformanceReview.initiativeAndOwnershipSection.tablesData.commentsResolved')] = document.commentsResolved,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(displayedUserActivityData) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(displayedUserActivityData) ? [] : tableData, columnColStyles: userActivityResolvingTableColgroup, tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] }));
};
